import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DisplayByMode } from '@epicuro-next/state/config-strip-state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'epc-toggle-display-mode',
  templateUrl: './toggle-display-mode.component.html',
  styleUrls: ['./toggle-display-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleDisplayModeComponent implements OnInit, OnChanges {
  public displayModeForm: UntypedFormGroup;
  public DisplayByMode = DisplayByMode;

  public displaySizeModeLabel = $localize`:Config Strip|Label for displayBy size toggle@@displayByToggleSize:Sizes`;
  public displayPrepackModeLabel = $localize`:Config Strip|Label for displayBy prepack toggle@@displayByTogglePrepack:Pre-packs`;

  private destroy$ = new Subject<void>();

  @Input()
  public displayByMode: DisplayByMode;
  @Input()
  public showPrepacks: boolean;
  @Input()
  public showSizes: boolean;

  @Output() public changedDisplayMode = new EventEmitter<DisplayByMode>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  public ngOnInit() {
    this.displayModeForm = this.formBuilder.group({
      displayMode: [this.displayByMode],
    });

    this.subscribeFormValue();
  }

  public ngOnChanges({ displayByMode }: SimpleChanges) {
    const displayMode = displayByMode?.currentValue;
    if (displayMode) {
      this.displayModeForm?.setValue({ displayMode }, { emitEvent: false });
    }
  }

  private subscribeFormValue() {
    this.displayModeForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ displayMode }) => {
        this.changedDisplayMode.emit(displayMode);
      });
  }
}
